import {Component, EventEmitter, inject, Input, OnChanges, OnDestroy, Output} from '@angular/core';
import {InlineArrayItemService} from '../../../core/inline-array-item.service';
import {FieldParameters} from '../../../core/definitions/field-parameters';
import {InlineArrayHeaderService} from '../inline-array-header.service';
import {InlineArrayHeaderContainer} from '../inline-array-header-container';
import {CrudService} from "../../../core/crud.service";
import {BaseModel} from "../../../core/definitions/base-model";

@Component({
    selector: 'app-edit-field-inline-array-item-top-bar',
    templateUrl: './edit-field-inline-array-item-top-bar.component.html',
    styleUrls: ['./edit-field-inline-array-item-top-bar.component.scss'],
    standalone: false
})
export class EditFieldInlineArrayItemTopBarComponent implements OnChanges, OnDestroy {
  // Injections
  public readonly crud: CrudService = inject(CrudService);
  private readonly inlineArrayHeaderSvc: InlineArrayHeaderService = inject(InlineArrayHeaderService);
  private readonly inlineArrayItemSvc: InlineArrayItemService = inject(InlineArrayItemService);

  item: BaseModel;
  @Input() fieldParameters: FieldParameters;
  @Output() setFirstInputFocus = new EventEmitter<object>();

  container: InlineArrayHeaderContainer;

  ngOnChanges() {
    this.item = this.fieldParameters.object;

    this.inlineArrayHeaderSvc.createContainer(
      this.fieldParameters.sectionsContainer.rootObject,
      this.fieldParameters.field,
      this.fieldParameters.index,
      this.fieldParameters.parentIndex,
      this.fieldParameters.grandparentIndex).then(container => {
      this.container = container;
      this.inlineArrayHeaderSvc.setValues(this.container, 2000);
    });
  }

  ngOnDestroy() {
    if (this.container?.timeOutId) {
      clearTimeout(this.container.timeOutId);
    }
  }

  toggleOpenItem() {
    if (this.item.$$activeDropdown) {
      return;
    }
    this.inlineArrayItemSvc.toggleInlineArrayItemOpen(this.fieldParameters);
    this.setFirstInputFocus.emit();
  }

  toggleOpenItemWithKey(/*event*/) {
    this.toggleOpenItem();
    this.setFirstInputFocus.emit();
  }
}
